module.exports = __webpack_public_path__ + "static/media/loc.b6e0f7a6.svg";